import * as Sentry from '@sentry/react';

// Logger reference for structured logging
export const logger = Sentry.logger;

export function initSentry() {
  Sentry.init({
    dsn: "https://393df97ae9ee5b9f28dc79f083a7fbed@o4510352223961088.ingest.us.sentry.io/4510536543109120",
    sendDefaultPii: true,
    enableLogs: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0,
  });
}

export function captureError(
  error: Error,
  context?: Record<string, unknown>
) {
  Sentry.captureException(error, {
    extra: context,
  });
}

export function captureMessage(
  message: string,
  level: Sentry.SeverityLevel = 'info',
  context?: Record<string, unknown>
) {
  Sentry.captureMessage(message, {
    level,
    extra: context,
  });
}

// Span instrumentation for performance tracking
export function startSpan<T>(
  options: { op: string; name: string },
  callback: (span: Sentry.Span) => T
): T {
  return Sentry.startSpan(options, callback);
}

// Async span instrumentation
export async function startSpanAsync<T>(
  options: { op: string; name: string },
  callback: (span: Sentry.Span) => Promise<T>
): Promise<T> {
  return Sentry.startSpan(options, callback);
}

export function setUser(user: { id: string; email?: string; name?: string }) {
  Sentry.setUser({
    id: user.id,
    email: user.email,
    username: user.name,
  });
}

export function clearUser() {
  Sentry.setUser(null);
}

export { Sentry };
